import React from "react";

export default function Download({
  fill = "white",
  width = "19",
  height = "19",
  ...others
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="1 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path fill={fill} d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
    </svg>
  );
}
